<template>
  <form @submit.prevent="fireSubmit" class="search__wrapper"
        :class="[
                        showButton && (this.value && this.value.length) ? 'active' : '',
                        inputFocused ? 'input_focused' : ''
                        ]">
    <div :class="['search__input_wrapper',(searchInputOutFromVisibleRange() && inputFocused) ? 'input__compact' : '']">
      <!-- DO NOT USE V-MODULE ON INPUT !!! THIS BROKEN ON MOBILE PHONES -->
      <textarea
          ref="searchInput"
          :rows="(searchInputOutFromVisibleRange() && inputFocused) ? '2' : '1'"
          :value="value"
          @input="onInput"
          placeholder="Всё уже нашлось"
          class="search__input"
          @focus="onInputFocus"
          @focusout="onInputFocusOut"
          @keydown="keyPressInput"
      ></textarea>
      <div v-if="icons" class="search__icons">
        <img
            v-for="(icon,index) of icons"
            :key="index"
            :src="icon.url || `https://favicon.yandex.net/favicon/v2/${icon.name}.com?size=32&stub=1`"
        >
      </div>
      <b class="search__input_cancel_button"
         @click="clearSearchInput"
         v-if="value && value.length && inputFocused"
      >x</b>
    </div>
    <button :disabled="!value" class="search__button">
      <svg xmlns="http://www.w3.org/2000/svg" width="21px" height="21px" viewBox="0 0 21 21">
        <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round"
           stroke-linejoin="round"
           transform="translate(4 6)">
          <path d="m9.5.497 4 4.002-4 4.001"/>
          <path d="m.5 4.5h13"/>
        </g>
      </svg>
    </button>
    <div class="search__predictors" v-if="predictors.length && showPredictors">
      <div v-for="(text, index) in predictors" :key="index" @click="changeSearch(text)"
           :class="activePredictor === index ? 'active' : ''"
           @mouseover="changeActivePredictor(index)"
           @mouseout="changeActivePredictor(null)"
      >
        {{ text }}
      </div>
    </div>
  </form>
</template>

<script>

import axios from "axios";

export default {
  name: "SearchForm",
  props: {
    value: String,
    icons: Array,
  },
  data() {
    return {
      showButton: false,
      inputFocused: false,
      showPredictors: false,
      predictors: [],
      activePredictor: null,
    }
  },
  computed: {

  },
  methods: {

    fireSubmit(){
      this.$emit('submit')
    },

    searchInputOutFromVisibleRange(){
      if(this.$refs.searchInput)
        return this.$refs.searchInput.getBoundingClientRect().width / this.value.length <= 11;
      return false;
    },

    onInput(e) {
      let has_new_lines = /\n/.test(e.target.value);
      if(has_new_lines){
        e.target.value = e.target.value.replace("\n","");
      }

      this.setSearchInput(e.target.value);

      if(has_new_lines){
        this.$refs.searchInput.blur();
        this.onInputFocusOut();
        this.fireSubmit();
      }
    },

    onInputFocus(){
      this.showPredictors = true
      this.showButton = true
      this.inputFocused = true;
      if(window.innerWidth < 700) {
        setTimeout(()=>{
          window.scrollTo(0,this.$refs.searchInput.getBoundingClientRect().top + window.scrollY - 30);
        },100)
      }

      this.$emit("focusin");
    },

    onInputFocusOut(){
      setTimeout(()=> {
        if(this.$refs.searchInput !== document.activeElement)
          this.inputFocused = false
        this.showPredictors = false;
      },500);
      this.$emit("focusout");
    },

    keyPressInput(e) {
      if (e.code === 'Enter') {
        if(this.activePredictor !== null){
          this.setSearchInput(this.predictors[this.activePredictor])
        }
        this.$nextTick(function (){
          this.fireSubmit();
        })

        this.$refs.searchInput.blur();
        e.preventDefault();
      }
      if (e.code === 'ArrowDown' || e.code === 'ArrowUp') {
        e.preventDefault()
        return false
      }
    },

    clearSearchInput(){
      this.setSearchInput('');
      this.$refs.searchInput.focus();
      setTimeout(()=>this.showPredictors = true,500);
    },

    changeActivePredictor(index) {
      this.activePredictor = index
    },

    onDocumentKeyPress(e) {
      e.preventDefault()
      if (e.code === 'ArrowDown' || e.code === 'ArrowUp') {
        if (e.code === 'ArrowDown') {
          if (this.activePredictor === null || this.activePredictor === this.predictors.length - 1) {
            this.activePredictor = 0
          } else {
            this.activePredictor = this.activePredictor + 1
          }
        }
        if (e.code === 'ArrowUp') {
          if (this.activePredictor === null || this.activePredictor === 0) {
            this.activePredictor = this.predictors.length - 1
          } else {
            this.activePredictor = this.activePredictor - 1
          }
        }

        return false
      }
    },

    async getPredictors() {
      this.predictors = []
      this.activePredictor = null

      const resp = await axios.get('https://netwiz.ru/ajax/google_autocomplete.php?letter='+decodeURIComponent(this.value))
      if (resp.status === 200 && resp.data) {
        this.predictors = resp.data;
      }
    },

    changeSearch(text) {
      this.setSearchInput(text);
      this.predictors = [];
      this.showPredictors = false;
      this.fireSubmit();
    },

    setSearchInput(text){
      this.$emit("input",text);
    },

    clickToClosePredictions(e){

      const exist = e.path.reduce((prev_value,currValue)=>{
        if(currValue !== document && currValue !== window && currValue.classList.contains('search__content')){
          return true;
        }
        return prev_value;
      },false)

      if (!exist) {
        this.showPredictors = false
      }
    }
  },
  watch: {
    showPredictors() {
      if (this.showPredictors) {
        document.addEventListener('click', this.clickToClosePredictions)
        document.addEventListener('keyup', this.onDocumentKeyPress)
      } else {
        document.removeEventListener('click', this.clickToClosePredictions)
        document.removeEventListener('keyup', this.onDocumentKeyPress)
      }
    },
    value(){
      if (this.value && this.value.length > 3) {
        this.getPredictors()
      }else{
        this.predictors = [];
      }
    },
  }

}
</script>

<style scoped lang="scss">
  .search__input_wrapper .search__icons {
    width: auto;
    display: flex;
    flex-wrap: nowrap;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    padding: 0 !important;
    left: unset !important;

    img {
      max-width: 27px;
      margin: 0 3px;
      border-radius: 5px;
      border: 2px solid #e9e9eb;
    }

    @media screen and (max-width: 768px){
      img {
        max-width: 20px;
        margin: 0;
      }
    }
  }

</style>